import { ConversationItem } from '@vivport/backend/types';
import { nanoid } from 'nanoid';

// Members can act on none of a validation envelope — codes, field paths, status numbers
// are developer diagnostics. They go to the console; the member gets a sentence.
export const TURN_REQUEST_FAILED_MESSAGE =
  "I couldn't send that just now — please try again. If it keeps happening, let support know.";

// Only a message we authored FOR a member may be shown to one. Everything else — a
// backend error string, a network message, a serialisation failure, any future throw
// site — is a developer diagnostic and falls back to the generic line above.
export class MemberFacingError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'MemberFacingError';
  }
}

export const FILE_UPLOAD_FAILED_MESSAGE = 'File upload failed. Upload did not complete.';
export const CONVERSATION_LOAD_FAILED_MESSAGE = 'Unable to load previous conversation.';

export function buildErrorAssistantItem(message: string): ConversationItem {
  return {
    id: `assistant-error-${nanoid(10)}`,
    kind: 'assistant_message',
    text: message,
  };
}

// Neo's opening line when a fresh chat starts in voice: spoken, shown, and deliberately
// not persisted — it does no work, so the NeoChat transcript starts at the member's first
// utterance and a resume simply does not replay it.
export function buildGreetingAssistantItem(text: string): ConversationItem {
  return {
    id: `assistant-greeting-${nanoid(10)}`,
    kind: 'assistant_message',
    text,
  };
}
